import React from "react";
import { Link } from "react-router-dom";
import careers from "../../data/careers";

const CSS = `
  .pf-lib { min-height: 100vh; padding: 110px 0 80px; position: relative; }
  .pf-lib-bg {
    position: absolute; inset: 0; pointer-events: none;
    background: radial-gradient(ellipse 50% 45% at 50% 10%, rgba(124,92,252,0.04) 0%, transparent 55%);
  }
  .pf-lib-wrap { max-width: 1100px; margin: 0 auto; padding: 0 24px; position: relative; z-index: 1; }
  .pf-lib-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 18px; margin-top: 44px;
  }
  .pf-lib-card {
    position: relative; padding: 28px 24px; border-radius: 20px;
    background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.05);
    overflow: hidden; cursor: pointer; text-decoration: none; color: inherit;
    transition: all 0.4s cubic-bezier(0.22,1,0.36,1);
    display: block;
    animation: fadeInUp 0.6s ease both;
  }
  .pf-lib-card::before {
    content: ''; position: absolute; top: 0; left: -100%; width: 60%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.03), transparent);
    transition: left 0.5s ease; pointer-events: none;
  }
  .pf-lib-card:hover::before { left: 160%; }
  .pf-lib-card:hover {
    background: rgba(255,255,255,0.045);
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0,0,0,0.2);
  }
  .pf-lib-card-top { display: flex; align-items: center; gap: 14px; margin-bottom: 14px; }
  .pf-lib-card-icon {
    width: 52px; height: 52px; border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    font-size: 1.6em; flex-shrink: 0; transition: all 0.3s ease;
  }
  .pf-lib-card:hover .pf-lib-card-icon { transform: scale(1.1) rotate(-5deg); }
  .pf-lib-card-title { font-weight: 800; font-size: 1.05em; color: #F0F0F5; }
  .pf-lib-card-tagline { font-size: 0.76em; color: rgba(240,240,245,0.35); margin-top: 2px; }
  .pf-lib-card-desc {
    font-size: 0.82em; color: rgba(240,240,245,0.38); line-height: 1.7; margin-bottom: 14px;
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
  }
  .pf-lib-card-footer { display: flex; justify-content: space-between; align-items: center; }
  .pf-lib-card-salary {
    font-family: 'JetBrains Mono', monospace; font-size: 0.72em; font-weight: 600;
    padding: 4px 12px; border-radius: 20px;
  }
  .pf-lib-card-arrow {
    font-size: 0.9em; color: rgba(240,240,245,0.15); transition: all 0.3s ease;
  }
  .pf-lib-card:hover .pf-lib-card-arrow { color: #FF6B35; transform: translateX(4px); }
  @media(max-width: 480px) { .pf-lib-grid { grid-template-columns: 1fr; } }
`;

export default function CareerLibrary() {
  return (
    <>
      <style>{CSS}</style>
      <section className="pf-lib">
        <div className="pf-lib-bg" />
        <div className="pf-lib-wrap">
          <div style={{ textAlign: "center" }}>
            <div className="section-badge">💼 Career Library</div>
            <h1 className="section-title">
              Explore <em>Every Career Path</em>
            </h1>
            <p className="section-subtitle" style={{ margin: "0 auto" }}>
              Detailed guides for India's most in-demand careers — salaries,
              skills, colleges, and complete roadmaps from 10th class.
            </p>
          </div>
          <div className="pf-lib-grid">
            {careers.map((c, i) => (
              <Link
                to={`/careers/${c.id}`}
                className="pf-lib-card"
                key={c.id}
                style={{
                  animationDelay: `${i * 0.08}s`,
                  borderColor: `${c.color}15`,
                }}
              >
                <div className="pf-lib-card-top">
                  <div
                    className="pf-lib-card-icon"
                    style={{
                      background: `${c.color}15`,
                      border: `1px solid ${c.color}25`,
                    }}
                  >
                    {c.emoji}
                  </div>
                  <div>
                    <div className="pf-lib-card-title">{c.title}</div>
                    <div className="pf-lib-card-tagline">{c.tagline}</div>
                  </div>
                </div>
                <div className="pf-lib-card-desc">{c.description}</div>
                <div className="pf-lib-card-footer">
                  <span
                    className="pf-lib-card-salary"
                    style={{
                      background: `${c.color}12`,
                      color: c.color,
                      border: `1px solid ${c.color}22`,
                    }}
                  >
                    {c.salaryRange.mid}
                  </span>
                  <span className="pf-lib-card-arrow">→</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
